module.exports = __webpack_public_path__ + "fonts/materialdesignicons-webfont.7a44ea19.woff2";